import React, { useEffect, useContext } from 'react';
import { Box } from '@mui/material';
import { ThemeContext } from "styled-components";

export default function Home() {
  const { colors } = useContext(ThemeContext);
  const style = {
    flexGrow: 1,
    position: "relative",
    width: "100%",
    padding: "40px 10px 10px",
    bgcolor: colors.c01,
    border: '0',
    boxShadow: 0,
    height: '96vh',
    color: colors.c04
  };

  useEffect(() => {

  });

  return (
    <Box sx={style}>

    </Box>
  )
}